export default {
	props: {

	},
	data() {
		return {

		}
	},
	created() {

	},
	methods: {
		dingtalkLogin() {
			let authCode = this.getRedirectUri(window.location.href, 'authCode')
			if (!authCode) {
				this.dingtalkLoginHref()
			} else {
				if (this.$store.state.system.systemdata) {
					this.$emit('login')
					return
				}
				this.$api.dingtalklogin({
					authCode: authCode
				}).then((res) => {
					this.authlogin(res)
				}, () => {
					this.dingtalkLoginHref()
				})
			}
		},
		dingtalkLoginHref() {
			let redirect_uri = this.getRedirectUri(window.location.href, 'redirect_uri')
			redirect_uri = encodeURIComponent((redirect_uri ? redirect_uri : window.location.href) + '?logincompany=' +
				this.logincompany)
			window.location.href = "https://login.dingtalk.com/oauth2/auth?redirect_uri=" + redirect_uri +
				"&response_type=code&client_id=" +
				window.config.dingtalk.client_id +
				"&scope=openid&prompt=consent"
		},
	},
}